import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import piHomeCard from "../pi-home-card/pi-home-card.vue";
import statisticsEcharts from "@/components/pi-statistics-echarts/pi-statistics-echarts.vue";
import piNoData from "@/components/pi-no-data/pi-no-data.vue";
import { getHomeStatChargeCurve } from "@/api/api-operation-service";
import i18n from "@/config/i18n";
const DATA_TYPE = {
    year: "3",
    month: "2",
    day: "1",
};
const DATA_TYPE_LIST = [
    { itemValue: i18n.t("year"), itemKey: DATA_TYPE.year },
    { itemValue: i18n.t("month"), itemKey: DATA_TYPE.month },
    { itemValue: i18n.t("day"), itemKey: DATA_TYPE.day },
];
let PiHomeChargeIncome = class PiHomeChargeIncome extends Vue {
    constructor() {
        super(...arguments);
        this.dateTypeList = DATA_TYPE_LIST;
        this.dataTypeDesc = {
            1: i18n.t("home.chargeEcharTypeDay"),
            2: i18n.t("home.chargeEcharTypeMonth"),
            3: i18n.t("home.chargeEcharTypeYear"),
        };
        this.echartShow = false; // 有统计数据才显示图表
        this.configData = {
            type: "line",
        };
        this.option = {
            color: ["#336CFF", "#10CDAC", "#BFD2E5", "#FFC01F"],
            grid: {
                top: "69",
                left: "20",
                right: "20",
            },
            yAxis: [
                {
                    name: i18n.t("home.feeYAxisName") + "(" + i18n.t("yuan") + ")",
                    show: true,
                    axisLabel: {},
                },
                { name: i18n.t("dl") + "(kW·h)", show: true },
            ],
            legend: {
                show: true,
            },
            series: [
                {
                    name: i18n.t("serverFee"),
                    type: "bar",
                    stack: "total",
                    key: "serviceAmountList",
                    barWidth: 8,
                    data: [],
                },
                {
                    name: i18n.t("eleFee"),
                    type: "bar",
                    stack: "total",
                    key: "elecAmountList",
                    barWidth: 8,
                    data: [],
                },
                {
                    name: i18n.t("delayFee"),
                    type: "bar",
                    stack: "total",
                    key: "delayAmountList",
                    barWidth: 8,
                    data: [],
                },
                {
                    name: i18n.t("dl"),
                    type: "line",
                    yAxisIndex: 1,
                    key: "elecList",
                    data: [],
                },
            ],
        };
        this.period = "1";
    }
    /**
     * 请求图表数据
     */
    async getHomeStatChargeCurve() {
        const ret = await getHomeStatChargeCurve({
            period: this.period,
        });
        if (ret.status === this.$config.apiStatus && ret.data[0]) {
            if (ret.data[0]) {
                this.saveData(ret.data[0]);
                this.echartShow = true;
            }
            else {
                this.echartShow = false;
            }
        }
    }
    /**
     * 参数赋值
     */
    saveData(data) {
        let chargeData = this.forData(data);
        this.option.series.map((item) => {
            item.data = chargeData[item.key];
        });
    }
    /**
     * 处理数据成图表需要的格式
     */
    forData(data) {
        let returnData = {};
        for (let i in data) {
            returnData[i] = data[i]?.map((item) => {
                return {
                    name: item.id,
                    value: item.value,
                };
            });
        }
        return returnData;
    }
    mounted() {
        this.getHomeStatChargeCurve();
    }
};
__decorate([
    Prop({ default: false })
], PiHomeChargeIncome.prototype, "isEchart", void 0);
PiHomeChargeIncome = __decorate([
    Component({
        components: {
            "pi-home-card": piHomeCard,
            "pi-statistics-echarts": statisticsEcharts,
            "pi-no-data": piNoData,
        },
    })
], PiHomeChargeIncome);
export default PiHomeChargeIncome;
